import styled from 'styled-components';

export const FormItemLabel = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  padding: 0 0 15px;
  color: var(--color-text-muted);
`;
